import { ReservationFlowProductCustomerFieldItem } from 'src/interfaces/reservation_flow';
import {
  regexpAlphanumeric,
  regexpNumeric,
  regexpPhone,
  regexpEmail,
  regexpKatakana,
} from 'src/libs/reservation-flow/regex';

const SKIP_FORMAT_VALIDATION_ANSWER_TYPE: ReservationFlowProductCustomerFieldItem['answer_type'][] =
  ['checkbox', 'radio_button', 'select_box'];

export const validateCustomerInfo: (
  item: ReservationFlowProductCustomerFieldItem,
  value: string | undefined,
) => { isValid: true } | { isValid: false; type: 'required' | 'format' } = (
  item,
  value,
) => {
  if (item.is_required) {
    if (typeof value === 'undefined' || value.length === 0) {
      return { isValid: false, type: 'required' };
    }
  }

  // is_required: false かつ valueがundefinedもしくは空文字列もしくは空配列の場合は、validateしない
  if (typeof value === 'undefined' || value.length === 0) {
    return { isValid: true };
  }

  if (
    !SKIP_FORMAT_VALIDATION_ANSWER_TYPE.includes(item.answer_type) &&
    item.validation_type !== null
  ) {
    switch (item.validation_type) {
      case 'alphanumeric':
        if (!regexpAlphanumeric.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'numeric':
        if (!regexpNumeric.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'phone':
        if (!regexpPhone.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'email':
        if (!regexpEmail.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'katakana':
        if (!regexpKatakana.test(value)) {
          return { isValid: false, type: 'format' };
        }
    }
  }

  return { isValid: true };
};
